import MapRouter from 'Modules/MapRouter';
import styles from './SlideUpMenus.module.scss';
import React, { useState, useEffect } from 'react';
import BaseballCard, { Tab } from 'Modules/PractitionerBaseballCard';
import useWindowSize from 'hooks/useWindowSize';
import { getLeadStateByPractitioner } from 'helpers/lead';
import { store } from "stores/Store";

interface SlideUpMenusProps {
  isOpen: boolean;
  selectedView: string;
  selectedTab?: Tab | undefined;
  setIsOpen: (isOpen: boolean) => void;
  onRouteChanged?: (setHasRouteChanged: (value: boolean) => void) => void;
}



const SlideUpMenus = ({ isOpen, selectedView, selectedTab, setIsOpen, onRouteChanged }: SlideUpMenusProps) => {

  const { width, height } = useWindowSize();
  const [isClosing, setIsClosing] = useState(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [hasRouteChanged, setHasRouteChanged] = useState(false);

  React.useEffect(() => {
    if (onRouteChanged) {
      onRouteChanged(setHasRouteChanged);
    }
  }, [onRouteChanged]);

  useEffect(() => {
    if (hasRouteChanged) {
    }
  }, [hasRouteChanged]);

  useEffect(() => {
    if (!isOpen && isClosing) {
      const timer = setTimeout(() => {
        setIsClosing(false);
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [isOpen, isClosing]);

  const handleClose = () => {
    setIsClosing(true);
    setIsOpen(false);
  };

  if (!isOpen && !isClosing) return null;


  const renderComponent = () => {
    console.log('selectedView', selectedView);
    switch (selectedView) {
      case 'createRoute':
        return <MapRouter setSelectedView={() => { }} setShowUnsavedChangesModal={setShowUnsavedChangesModal}
          showUnsavedChangesModal={showUnsavedChangesModal} hasRouteChanged={hasRouteChanged}
          setHasRouteChanged={setHasRouteChanged} />
      default:
        // return <div style={{ width: width > 480 ? width * .6 : width * .9, height: height * .8, position: 'relative' }}><BaseballCard backHandler={() => handleClose()} tab={selectedTab ?? Tab.SUMMARY} generalNotes=''/></div>
        return (
          <div className={styles.baseballCardOverlay}>
            <div
              className={styles.baseballCardModal}
              onClick={e => e.stopPropagation()}
            >
              <div className={styles.baseballCardModalContent} style={{ width: width > 480 ? width * .6 : width * .9, height: height * .8, position: 'relative', paddingTop: "40px", }}>
                <div className={getLeadStateByPractitioner(store.currentPractitioner) ? styles["tinted-border"] : ""}>
                  {getLeadStateByPractitioner(store.currentPractitioner) && (
                    <div className={styles["top-message"]}>
                      {getLeadStateByPractitioner(store.currentPractitioner)}
                    </div>
                  )}
                </div>
                <BaseballCard backHandler={() => handleClose()} tab={Tab.SUMMARY} generalNotes='' />
              </div>
            </div>
          </div>
        )
    }
  }
  return (
    <div
      className={`${styles.wrapper} ${isOpen ? styles.open : isClosing ? styles.closing : ''}`}
    >
      <div className={styles.container}>
        <button className={styles.closeButton} onClick={handleClose}>×</button>
        {renderComponent()}
      </div>
    </div>
  )
}

export default SlideUpMenus;